import { BASE_URL } from "@/services/api/base";

export const getApplicationEndpoint = `${BASE_URL}/Application/Get`;
